module.exports = __webpack_public_path__ + "img/homeBG.ba6632b9.jpg";